<template>
    <div>
        <nav class="navbar navbar-light">
            <img src="../assets/logo-home.png" alt="Editora do Brasil" class="img-fluid mx-auto d-block">
        </nav>
        <div class="container-fluid">       
            <div class="text-center btndoubtsdesktop">
                <button type="button" class="btn buttonhome" data-toggle="modal" data-target=".bd-doubts-modal-lg"> 
                    Dúvidas? Entre em contato
                </button>
            </div>
            <div class="row centro justify-content-center">
                <div class="col-md-6 align-self-center">               
                    <div class="form-box mx-auto">
                        <div class="form-group textlogin">
                            <p>Livro Digital - Aluno - PNLD</p>                          
                                <div class="linegreen mx-auto"> </div>
                                É aluno da <b>Rede Pública de Ensino</b> e deseja acessar sua coleção
                                da Editora do Brasil em formato digital?                        
                            <h2>Criamos uma plataforma exclusiva para você! :D</h2>                         
                        </div>                  
                        <form id="formLogin" @submit.prevent="enviar">
                            <div class="form-group">
                                <label for="emailLogin" class="label">E-mail</label>
                                <div class="input-group">
                                    <input type="email" id="emailLogin" v-model="formLogin.Email" class="form-control" maxlength="100">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="password" class="label">Senha</label>
                                <div class="input-group">
                                    <input type="password" id="password" v-model="formLogin.Senha" class="form-control" maxlength="250">
                                </div>
                            </div>
                            <div class="form-group">
                                <div id="vazioMsg" class="alert alert-danger fade show" role="alert">
                                    Digite seus dados de acesso.
                                </div>
                                <div id="errorMsg" class="alert alert-danger fade show" role="alert">
                                    Usuário não cadastrado ou senha incorreta.
                                </div>
                            </div>
                            <div class="form-group">
                                <button v-on:click.prevent="enviar" class="btn btn-submit btn-block">Entrar</button>
                            </div>
                            <div class="forgotpassword">
                                <router-link to="/recuperar-senha">Esqueci a minha senha</router-link>
                            </div>
                            <div class="form-group register">
                                <p>Ainda não se registrou?</p>
                                <router-link to="/cadastro" class="btn btn-cadastro btn-block">Cadastre-se</router-link>                                
                            </div>
                            <div class="form-group register">
                                <a target="_blank" href="https://editoradobrasil.com.br/leb">É professor? Acesse seu livro.</a>
                            </div>
                        </form>     
                        <div class="forgotpassword">
                            <a href="http://politicadecookies.editoradobrasil.com.br" target="_blank" rel="noopener noreferrer">Políticas de Cookies</a> | <a href="https://conteudos.editoradobrasil.com.br/politicas/politicas-de-cookies-e-privacidade.pdf" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
                        </div>                   
                    </div>
                </div>
            </div>
            <div class="text-center btndoubtsmobile">
                <button type="button" class="btn buttonhome" data-toggle="modal" data-target=".bd-doubts-modal-lg"> 
                    Dúvidas? Entre em contato
                </button>
            </div>
            <div class="modal fade bd-doubts-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg">                   
                    <div class="modal-content doubthome">
                        <div class="modal-header deletebordermodal">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <a style="font-size:12px">Fechar</a> &nbsp; <img src="../assets/close.png">
                            </button>
                        </div>
                        <b>Dúvidas?</b>
                        <div class="linegreen mx-auto"> </div>
                        <h1>Entre em contato conosco.</h1>
                        <h2>Horário de funcionamento</h2>
                        <h3>Segunda a sexta das 8h às 18h</h3>
                        <div class="form-group col-sm-12">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="card cardhomemobile">
                                        <div class="card-body cardhome">                                    
                                            <p class="card-text">MENSAGENS VIA WHATSAPP</p>
                                            <img src="../assets/whatsapp.png">
                                            &nbsp; <a href="http://api.whatsapp.com/send?1=pt_BR&phone=5511993295316" >(11)99329-5316</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="card">
                                        <div class="card-body cardhome">                                        
                                            <p class="card-text">POR E-MAIL</p>
                                            <img src="../assets/e-mail.png">
                                            &nbsp; <a href="mailto:site@editoradobrasil.com.br">Enviar mensagem</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <nav class="navbar navbar-light footerhome">
                            <img src="../assets/logo-home.png" alt="Editora do Brasil" class="img-fluid mx-auto d-block">
                        </nav>
                    </div>                  
                </div>              
            </div>

            <!-- MODAL LGPD -->
            <div class="bg" id="bg">
                <div class="cookies">
                <p>Utilizamos cookies para oferecer melhor experiência, melhorar o desempenho, analisar como você interage em nosso site e personalizar o conteúdo. Confira nossas <a href="http://politicadecookies.editoradobrasil.com.br" target="_blank" rel="noopener noreferrer">Políticas de Cookies</a> e <a href="https://conteudos.editoradobrasil.com.br/politicas/politicas-de-cookies-e-privacidade.pdf" target="_blank" rel="noopener noreferrer">Privacidade</a>.<button class="btn-cookies" id="btn-cookies">Estou de acordo</button></p>
                <!-- <a href="#" class="close" data-dismiss="modal"><i class="material-icons md-24">close</i></a> -->
                </div>
            </div>
            <!-- MENSAGEM DE MANUTENÇÃO -->
            <div class="fundo-msg" id="fundo-msg">
                <div class="box-msg">
                    <img src="../assets/img/logocolor.svg" class="logo img-fluid" />
                    <h4>Não é possível acessar no momento.<br>Sistema em manutenção temporária.</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dados from '../services/login'
import {http} from '../services/APIservice'

export default {
    name: 'Login',
    data() {
        return {
            //Sets para validação
            formLogin: {
                Email: '',
                Senha: ''
            }
        }
    },
    methods: {
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
        },
        enviar() {
            var userEmail = this.formLogin.Email;
            var userPassword = this.formLogin.Senha;
            //console.log(userEmail, userPassword);

            if (userEmail == '' || userPassword == '') {
                document.getElementById('vazioMsg').style.display = 'block';
            } else {
                document.getElementById('vazioMsg').style.display = 'none';
                Dados.login(userEmail, userPassword).then(response => {

                    // console.log(response.data.usuario)
                    // console.log(response.status)

                    if (response.data.token) {
                        localStorage.setItem('user', JSON.stringify(response.data));
                    }

                    if (response.status == 200) {
                        document.getElementById('errorMsg').style.display = 'none';
                        var url = window.location.href;
                        window.location.href = url + 'livros';
                    }
                })
                .catch(err => {
                    document.getElementById('errorMsg').style.display = 'block';
                    console.log(err)
                })
            }
        },
        getDateTimeNow() {
            return http.post("Usuario/GetDateTimeNow")
                .then(res => {
                    console.log(res);

                        var dateServer = new Date(res.data.getDatetimeNow);
                        var dateInicio =  new Date('2021-06-18T16:00:00');
                        var dateExpira =  new Date('2021-06-18T16:01:00');

                        console.log(dateServer);
                        console.log(dateExpira);

                        if(dateServer > dateInicio){
                        document.getElementById('fundo-msg').style.display = 'block';
                        }
                        if(dateServer > dateExpira){
                        document.getElementById('fundo-msg').style.display = 'none';
                        }
                })
                // .catch(error => {
                //     console.log(error.res.status);
                // });
            }
    },
    mounted() {
        (function () {
            "use strict";
            
            var cookieName = 'cookieConsentPnldMecRed'; // nome do cookie
            var cookieLifetime = 365; // cookie expira em...
            
            /**
            * Set cookie
            * @param cname - cookie name
            * @param cvalue - cookie value
            * @param exdays - expiry in days
            */
            var _setCookie = function (cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            };
            
            /**
            * Get cookie
            * @param cname - cookie name
            * @returns string
            */
            var _getCookie = function (cname) {
                var name = cname + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            };
            
            /**
            * Verifica se já foi aceito
            */
            var _shouldShowPopup = function () {
                if (_getCookie(cookieName)) {
                    return false;
                } else {
                    return true;
                }
            };
            
            // Mostra o cookie popup on caso nao tenha sido aceitado
            if (_shouldShowPopup()) {
                console.log('show lgpd');
                document.getElementById('bg').style.display = 'block';
            }
            
            // Some com o modal cookie
            document.getElementById('btn-cookies').addEventListener("mousedown", function(){
                _setCookie(cookieName, 1, cookieLifetime);
                document.querySelector('.bg').style.display = 'none';
            });
            
        })();

        this.getDateTimeNow();
    }
}
</script>
